var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiAutocomplete from '@material-ui/lab/Autocomplete';
import styled from 'styled-components';
import { DownCaretIcon } from '../Icon';
var StyledAutocomplete = styled(MuiAutocomplete)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] {\n      // Padding for this element is 9px normally, 6px if small/dense.\n      // Stabilize left padding to 8px to align with labels and TextFields.\n      padding-left: 8px;\n    }\n  }\n"], ["\n  &&& {\n    .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] {\n      // Padding for this element is 9px normally, 6px if small/dense.\n      // Stabilize left padding to 8px to align with labels and TextFields.\n      padding-left: 8px;\n    }\n  }\n"])));
/**
 * Kareo wrapped component of the Material-UI Autocomplete. The prop API has been limited to props defined in AutocompleteProps.
 *
 * The autocomplete is a normal text input enhanced by a panel of suggested options.
 *
 * Material-UI Autocomplete: [Docs](https://v4.mui.com/components/autocomplete/), [API](https://v4.mui.com/api/autocomplete/)
 *
 * @storybook: [Autocomplete](http://design.kareoprod.ent/design-system/?path=/story/components-inputs-autocomplete--basic)
 */
var Autocomplete = function (props) {
    return (React.createElement(StyledAutocomplete, __assign({}, props, { popupIcon: React.createElement(DownCaretIcon, { fontSize: "xsmall" }) })));
};
Autocomplete.defaultProps = {};
export default Autocomplete;
var templateObject_1;
